import React from 'react';
import styled from '@emotion/styled';
import breakpoints from './Theme/breakpoints';
import grey from './Palettes/grey';

const BiographyWrapper = styled.div`
  margin: 8px 0;
  padding: 0px 12px 24px 4px;
  border-bottom: 1px solid ${grey[200]};
  @media (min-width: ${breakpoints.sm}px) {
    display: flex;
  }
  @media (min-width: ${breakpoints.md}px) {
    padding: 4px 12px 24px 4px;
  }
`;

const AuthorImageContainer = styled.div`
  border: 1px solid ${grey[325]};
  overflow: hidden;
  float: left;
  width: 90px;
  height: 90px;
  border-radius: 45px;
  margin: 0 20px 8px 0;
  @media (min-width: ${breakpoints.sm}px) {
    float: none;
    width: 120px;
    height: 120px;
    border-radius: 60px;
    margin: 0 20px 8px 4px;
  }
`;

const BiographyBody = styled.div`
  padding: 4px 0 0;


  @media (min-width: ${breakpoints.sm}px) {
    width: calc(100% - 148px);
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: calc(100% - 232px);
  }
  p {
    margin: 0;
  }
  line-height: ${
    (properties) => properties.theme.typography?.body2?.lineHeight
  };
  font-size: ${
    (properties) => properties.theme.typography?.body2?.fontSize
  };
  font-family: ${
    (properties) => properties.theme.fonts.primary
  };
  color: ${grey[900]};
  @media (min-width: ${breakpoints.sm}px) {
  line-height: ${
    (properties) => properties.theme.typography?.body1?.lineHeight
  };
  }
  @media (min-width: ${breakpoints.md}px) {
  font-size: ${
    (properties) => properties.theme.typography?.body1?.fontSize
  };
  }
`;

interface AuthorBiographyProperties {
  authorImage?: React.ReactNode;
  bio: string;
}

const AuthorBiography = ({
  authorImage,
  bio,
}: AuthorBiographyProperties) => (
  <BiographyWrapper>
    {authorImage && (
      <AuthorImageContainer>
        {authorImage}
      </AuthorImageContainer>
    )}
    <BiographyBody dangerouslySetInnerHTML={{ __html: bio }} />
  </BiographyWrapper>
);

export default AuthorBiography;
